import { createBrowserRouter, RouteObject, RouterProvider } from 'react-router-dom';
import { AuthGuard } from './guards';
import { ManagementAppRoutes } from './management';
import ManagementLayout from '../layouts/management';
import LogisticsLayout from '../layouts/logistics';
import useWindowDimensions from '../hooks/useWindowsDimensions';
import Invoice from '../common/components/invoice';
import EWayBill from '../common/components/ewaybill';
import { onexAppRoutes } from './onex';
import TrainerLayout from '../layouts/trainer';
import MentorLayout from '../layouts/mentor';
import { TrainerRoutes } from './trainer';
import { MentorRoutes } from './mentor';
import { VentureRoutes } from './venture';
import VentureLayout from '../layouts/venture';
import { AgencyRoutes } from './agency';
import AgencyLayout from '../layouts/agency';
import OneuserLayout from '../layouts/oneuser';
import { OneuserRoutes } from './oneuser';
import CandidateLayout from '../layouts/candidate';
import { CandidateRoutes } from './candidate';
import PartnerLayout from '../layouts/partner';
import { PartnerRoutes } from './partner';
import { AllVendors } from '../pages/biznet';
import LoginLayout from '../layouts/login';
import { LoginRoutes } from './login/routes';
import IxeLogin from '../pages/auth/ixe-login';
import OneXLayout from '../layouts/one-x';
import { onexNewAppRoutes } from './onex/new';
import { onexV2AppRoutes } from './onex/newV2';
import OneXV2Layout from '../layouts/one-xv2';
import { communityHubRoutes } from './onex/communityhub';
import CommunityHubLayout from '../layouts/communityhub';



const AppRouter: React.FC = () => {
  let SUBSCRIPTION_TYPE: string = process.env.REACT_APP_SUBSCRIPTION_TYPE || '';
  console.log('SUBSCRIPTION_TYPE', SUBSCRIPTION_TYPE)
  const { height, width } = useWindowDimensions();

  const prepareOnexRoutes = () => {
    const routes: RouteObject[] = [
      {
        path: '/order/invoice/:id',
        element: <Invoice />
      },
      {
        path: '/order/e-way/:id',
        element: <EWayBill />
      },
      // {
      //   path: '/',
      //   element: <LogisticsLayout />, children: onexAppRoutes({ width }),
      // },
      // {
      //   path: '/new',
      //   element: <OneXLayout />, children: onexNewAppRoutes({ width }),
      // },
       {
        path: '/',
        element: <OneXV2Layout />, children: onexV2AppRoutes({ width }),
      },
      //  {
      //   path: '/communities',
      //   element: <CommunityHubLayout />, children: communityHubRoutes({ width }),
      // },
      {
        path: '/trainer/*',
        element: <AuthGuard><TrainerLayout /></AuthGuard>, children: TrainerRoutes(),
      },
      {
        path: '/candidate/*',
        element: <AuthGuard><CandidateLayout /></AuthGuard>, children: CandidateRoutes(),
      },
      {
        path: '/partner/*',
        element: <AuthGuard><PartnerLayout /></AuthGuard>, children: PartnerRoutes(),
      },
      {
        path: '/mentor/*',
        element: <AuthGuard><MentorLayout /></AuthGuard>, children: MentorRoutes(),
      },

      {
        path: '/management/*',
        element: <AuthGuard><ManagementLayout /></AuthGuard>, children: ManagementAppRoutes(),
      },

      {
        path: '/venture/*',
        element: <AuthGuard><VentureLayout /></AuthGuard>, children: VentureRoutes(),
      },
      {
        path: '/agencies/*',
        element: <AuthGuard><AgencyLayout /></AuthGuard>, children: AgencyRoutes(),
      },
      {
        path: '/oneuser/*',
        element: <AuthGuard><OneuserLayout /></AuthGuard>, children: OneuserRoutes(),
      },

       {
        path: "/ventures",
        element: (
          <AuthGuard>
            <LogisticsLayout />
          </AuthGuard>
        ),
        children: [
          {
            index: true,
            element: <AllVendors />,
          },
        ],
      },
      

    ];
    return routes;
  }


      //   {
      //   path: '/venture/*',
      //   element: <AuthGuard><VentureLayout /></AuthGuard>, children: VentureRoutes(),
      // },
   const prepareXeRoutes = () => {
    const routes: RouteObject[] = [
     
      {
        path: '/',
        element: <AuthGuard><LoginLayout /></AuthGuard>, children: LoginRoutes(),
      },
      {
        path: '/mobile/*',
        element: <AuthGuard><LoginLayout /></AuthGuard>, children: LoginRoutes(),
      },
      {
        path: '/tablet/*',
        element: <AuthGuard><LoginLayout /></AuthGuard>, children: LoginRoutes(),
      },
  {
        path: '/trainer/*',
        element: <AuthGuard><TrainerLayout /></AuthGuard>, children: TrainerRoutes(),
      },
      {
        path: '/candidate/*',
        element: <AuthGuard><CandidateLayout /></AuthGuard>, children: CandidateRoutes(),
      },
      {
        path: '/partner/*',
        element: <AuthGuard><PartnerLayout /></AuthGuard>, children: PartnerRoutes(),
      },
      {
        path: '/mentor/*',
        element: <AuthGuard><MentorLayout /></AuthGuard>, children: MentorRoutes(),
      },

      {
        path: '/management/*',
        element: <AuthGuard><ManagementLayout /></AuthGuard>, children: ManagementAppRoutes(),
      },

      {
        path: '/venture/*',
        element: <AuthGuard><VentureLayout /></AuthGuard>, children: VentureRoutes(),
      },
      {
        path: '/agencies/*',
        element: <AuthGuard><AgencyLayout /></AuthGuard>, children: AgencyRoutes(),
      },
      {
        path: '/oneuser/*',
        element: <AuthGuard><OneuserLayout /></AuthGuard>, children: OneuserRoutes(),
      },
    ];
    return routes;
  }

    if (window.location.hostname.includes('xe.digiit')) {
     return  <RouterProvider router={createBrowserRouter(prepareXeRoutes())} />
  }

  // const test="https://onex.xe.digiit.io"
  //   if (test.includes('xe.digiit')) {
  //    return  <RouterProvider router={createBrowserRouter(prepareXeRoutes())} />
  // }

  switch (SUBSCRIPTION_TYPE) {
    case 'onex':
      console.log('Running onex')
      return (
        <RouterProvider router={createBrowserRouter(prepareOnexRoutes())} />
      );

    default:
      return null
  }

  

};

export default AppRouter;